import Preset, { AtomisablePreset } from 'domain/entity/preset';

export type Features = Feature[];

export default class Feature {
    constructor(readonly name: string, readonly key: string, readonly presets: Preset[], readonly atomisablePresets: AtomisablePreset[]) {}
}
